export default __webpack_public_path__ + "static/zitrone-2a3e2ee632e14b0a4ecc9f1de3395fee.png";